import React from "react";
import styles from "./HomeSkeleton.module.css";

const HomeSkeleton: React.FC = () => {
  return (
    <div className="container">
      {" "}
      {/* Add container class to match Home component */}
      <div className={styles.homeSkeletonContainer}>
        {/* Hero Banner Skeleton */}
        <div className={styles.heroSkeleton}></div>

        {/* Products Slider Sections */}
        {[...Array(3)].map((_, index) => (
          <div key={index} className={styles.sliderSectionSkeleton}>
            <div className={styles.sectionHeaderSkeleton}>
              <div className={styles.titleSkeleton}></div>
              <div className={styles.subtitleSkeleton}></div>
            </div>
            <div className={styles.productSliderSkeleton}>
              {[...Array(6)].map((_, idx) => (
                <div key={idx} className={styles.productCardSkeleton}>
                  <div className={styles.productImageSkeleton}></div>
                  <div className={styles.productContentSkeleton}>
                    <div className={styles.productPriceSkeleton}></div>
                    <div className={styles.productNameSkeleton}></div>
                    <div className={styles.productDeliverySkeleton}></div>
                    <div className={styles.productSwatchesSkeleton}>
                      {[...Array(3)].map((_, swatchIdx) => (
                        <div
                          key={swatchIdx}
                          className={styles.colorSwatchSkeleton}
                        ></div>
                      ))}
                    </div>
                  </div>
                  <div className={styles.productButtonSkeleton}></div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Benefits Section */}
        <div className={styles.benefitsSectionSkeleton}>
          <div className={styles.benefitsTitleSkeleton}></div>
          <div className={styles.benefitsContainerSkeleton}>
            {[...Array(4)].map((_, index) => (
              <div key={index} className={styles.benefitItemSkeleton}>
                <div className={styles.benefitIconSkeleton}></div>
                <div className={styles.benefitTextSkeleton}></div>
              </div>
            ))}
          </div>
        </div>

        {/* Banner Row */}
        <div className={styles.bannerRowSkeleton}>
          <div className={styles.bannerSkeleton}></div>
          <div className={styles.bannerSkeleton}></div>
        </div>
      </div>
    </div>
  );
};

export default HomeSkeleton;
